import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/core/toast.service';
import { ProdutoapiService } from 'src/app/dao/api_produto.service';

@Component({
  selector: 'app-categoria-selecao-form-ativo',
  templateUrl: './categoria-selecao-form-ativo.page.html',
  styleUrls: ['./categoria-selecao-form-ativo.page.scss'],
})
export class CategoriaSelecaoFormAtivoPage implements OnInit {



  categorias = [];

  categoriasAux = [];

  formCatId;
   // tslint:disable-next-line: max-line-length
  constructor(private router: Router, private route: ActivatedRoute, private toast: ToastService, private apiproduto: ProdutoapiService) { }

  ngOnInit() {
    this.loadCategorias();

    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      // tslint:disable-next-line: radix
    }
  }

  ionViewWillEnter() {
    this.loadCategorias();
  }





  async onSubmit2(idCat) {
    try {
      this.formCatId = idCat;
      this.router.navigate(['/produto-list/', this.formCatId]);
    } catch (error) {
      this.toast.showError('Ocorreu um erro');
      console.log(error);
    }

  }


  async loadCategorias() {
    this.apiproduto.listarAllCategorias().then(res => {
      this.categoriasAux = res;
      //this.toast.showSucess('Categorias obtidas com sucesso!');
    }).catch(async err => {
      console.log('err', err);
      this.toast.showError('Erro ao obter Categorias');
    });
  }


}
